export default {
  // For PrimeVue 3
  accordiontab: {
    root: {
      class: 'mb-1',
    },
  },
}
